import { createApp } from "vue/dist/vue.esm-browser.prod";
import { createClient } from "@sanity/client";
import Spotlight from "spotlight.js";
import shuffle from "just-shuffle";
import imageUrlBuilder from "@sanity/image-url";

const canonicalBaseUrl = "https://sepisa.com.mx/proyecto";

function setMeta(selector, attribute, value) {
	const element = document.querySelector(selector);
	if (element && value) element.setAttribute(attribute, value);
}

function plainText(value) {
	if (!value) return "";
	if (typeof value === "string") return value.replace(/\s+/g, " ").trim();
	return "";
}

function updateProjectMetadata(project, slug) {
	const url = `${canonicalBaseUrl}?p=${encodeURIComponent(slug)}`;
	const description = plainText(project.objetivo || project.descripcion) ||
		`Proyecto de ${project.tipo || "infraestructura eléctrica"} desarrollado por SEPISA.`;
	const title = `${project.titulo} | Proyecto de infraestructura eléctrica | SEPISA`;

	document.title = title;
	setMeta('meta[name="description"]', "content", description.slice(0, 160));
	setMeta('meta[property="og:title"]', "content", title);
	setMeta('meta[property="og:description"]', "content", description.slice(0, 160));
	setMeta('meta[property="og:url"]', "content", url);
	setMeta('meta[property="og:image"]', "content", project.posterUrl);
	setMeta('meta[property="og:image:secure_url"]', "content", project.posterUrl);
	setMeta('meta[name="twitter:title"]', "content", title);
	setMeta('meta[name="twitter:description"]', "content", description.slice(0, 160));
	setMeta('meta[name="twitter:image"]', "content", project.posterUrl);
	setMeta('link[rel="canonical"]', "href", url);

	const previousSchema = document.getElementById("project-schema");
	if (previousSchema) previousSchema.remove();

	const schema = document.createElement("script");
	schema.id = "project-schema";
	schema.type = "application/ld+json";
	schema.textContent = JSON.stringify({
		"@context": "https://schema.org",
		"@type": "CreativeWork",
		name: project.titulo,
		description,
		url,
		image: project.posterUrl,
		provider: {
			"@type": "Organization",
			name: "SEPISA, S.A. de C.V.",
			url: "https://sepisa.com.mx/",
		},
	});
	document.head.appendChild(schema);
}

createApp({
	data() {
		return {
			item: null,
			items: null,
			loading: true,
			loadingItems: true,
		};
	},
	mounted: async function () {
		// get url slug
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const params = urlParams.get("p");

		// sanity client
		const client = createClient({
			projectId: "9fvagzap",
			dataset: "production",
			useCdn: true, // set to `false` to bypass the edge cache
			apiVersion: "2023-05-03", // use current date (YYYY-MM-DD) to target the latest API version
		});

		// get doc
		try {
			const post = await client.fetch(
				`*[_type == "proyectos" && slug.current == $slug][0]{
					titulo,
					anio,
					tipo,
					ubicacion,
					"posterUrl": poster.asset->url,
					soluciones,
					descripcion,
					objetivo,
					videoid,
					"galeria": galeria[].asset->url
				}`,
				{ slug: params }
			);

			this.item = post;
			if (post && params) updateProjectMetadata(post, params);
			this.loading = false;
		} catch (error) {
			console.log(error);
			this.loading = true;
		}

		// get related posts
		try {
			const posts = await client.fetch('*[_type == "proyectos"]');
			this.items = posts;
			this.loadingItems = false;
		} catch (error) {
			console.log(error);
			this.loadingItems = true;
		}
	},
	computed: {
		relatedItems() {
			if (!this.loadingItems) {
				let data = shuffle(this.items);
				data = data.slice(0, 3);
				return data;
			}
		},
	},
	methods: {
		urlFor(source) {
			const builder = imageUrlBuilder({
				projectId: "9fvagzap",
				dataset: "production",
			});

			return builder.image(source);
		},
	},
}).mount("#app");
